export const environment = {    
    production:true,
    base_url:"https://prodapi.aed365.com/reseller/api/",
    googleLocationKey:"AIzaSyDSKO2PHGzkQE-zCsPbS0BpZQYIaM9J8w0",
    StripePrivateKey:"pk_live_51ITK1XGKjBC0ktIwDib7YIARDvYDNPO3YdrjgjqtbOPEGhz5f0ukyuJsUT0O3dFtate0RUn0eWg2fZ3L4IgxsmO300pJWFfmHu",
    dashboard_url:"https://reseller.aed365.com/dashboard",
    company_url:"https://hub.aed365.com/verify-admin?logintoken=",
    LOGIN_COMPANY: 'https://hub.aed365.com/verify-admin?logintoken='
};
